import RoomRoundedIcon from '@mui/icons-material/RoomRounded';
import { GeocodeGoogleOption } from '#service/autocomplete-service/option';

const addressSelector = (label, address) => {
  const city = address.find(a => a.types.includes('locality'));
  return city ? label.split(`, ${city.long_name}`)[0] : undefined;
};

const fieldSelector = (keyNames, address) => {
  const component = address.find(a => keyNames.find(k => a.types.includes(k))) || {};
  return component.long_name || undefined;
};

const addressFields = [
  { id: 1, name: 'address1', label: 'Address 1', value: addressSelector },
  { id: 2, name: 'address2', label: 'Address 2' },
  { id: 3, name: 'city', label: 'City', value: fieldSelector, key: ['locality'] },
  { id: 4, name: 'state', label: 'State', value: fieldSelector, key: ['administrative_area_level_1', 'administrative_area_level_2'] },
  { id: 5, name: 'country', label: 'Country', value: fieldSelector, key: ['country'] },
  { id: 6, name: 'zipCode', label: 'Zip code', value: fieldSelector, key: ['postal_code'] }
];

class GeocodeGoogleOptionsService {
  #apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

  #apiKey = '';

  constructor() {
    this.#apiKey = import.meta.env?.VITE_MAPS_JS_API ?? '';
  }

  async getOptions(value, fetchOptions) {
    if (!value) {
      return [];
    }

    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions);

    return GeocodeGoogleOptionsService.transformOptions(fetchedOptions);
  }

  async fetchOptionsRaw(value, fetchOptions = {}) {
    const searchParams = new URLSearchParams({
      latlng: value,
      key: this.#apiKey
    });

    const res = await fetch(`${this.#apiUrl}?${searchParams.toString()}`, { ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const options = await res.json();

    return options.results ?? [];
  }

  static transformOptions(options) {
    return options.map(option => {
      const {
        place_id: placeId,
        formatted_address: formattedAddress,
        address_components: addressComponents,
        geometry
      } = option;

      const address = addressFields.reduce((a, c) => {
        if (!c.value) {
          return a;
        }
        return {
          ...a,
          [c.name]: c.key ?
            c.value(c.key, addressComponents) :
            c.value(formattedAddress, addressComponents)
        };
      }, {});

      const location = { lat: geometry.location.lat, lng: geometry.location.lng };

      const details = { address, locations: [location], placeId };

      return new GeocodeGoogleOption(formattedAddress, RoomRoundedIcon, details);
    });
  }
}

export default GeocodeGoogleOptionsService;
